/* eslint-disable */
import type { RedditPixelAPI } from '@/global';

import { ENV } from '@/environment/client';

export function initRedditPixel() {
  (function (w, d) {
    if (!w.rdt) {
      var p = function (...args: unknown[]) {
        p.sendEvent ? p.sendEvent.apply(p, args) : p.callQueue.push(args);
      } as RedditPixelAPI;
      p.callQueue = [];
      w.rdt = p;
      var t = d.createElement('script');
      t.src = 'https://www.redditstatic.com/ads/pixel.js';
      t.async = !0;
      var s = d.getElementsByTagName('script')[0];
      s.parentNode?.insertBefore(t, s);
    }
  })(window, document);
  window.rdt('init', ENV.NEXT_PUBLIC_REDDIT_PIXEL_ID);
  window.rdt('track', 'PageVisit');
}
